import { render, staticRenderFns } from "./LotListPaginationButtons.vue?vue&type=template&id=0871bdde&scoped=true&"
import script from "./LotListPaginationButtons.vue?vue&type=script&lang=js&"
export * from "./LotListPaginationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871bdde",
  null
  
)

export default component.exports